import React, { useEffect, useState } from "react";
import { parseExcel } from "../utils/excelParser";
import { motion } from "framer-motion";

const Timeline = ({ language = "fr", wineColor = "rouge" }) => {
  const [timelineData, setTimelineData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await parseExcel("/data/CODE.xlsx", wineColor, language);
        setTimelineData(data || []);
      } catch (error) {
        console.error("Erreur lors de la récupération des données :", error);
      }
    };

    fetchData();
  }, [wineColor, language]);

  const getSvgSize = (trigram) => {
    const defaultSize = 100;
    const hundredsDigit = parseInt(trigram.toString().charAt(0), 10);

    if (hundredsDigit === 2) {
      return defaultSize / 1.45;
    } else if (hundredsDigit === 3) {
      return defaultSize / (1.45 * 1.75);
    }
    return defaultSize;
  };

  return (
    <div className="timeline-container">
 

      {timelineData.length > 0 ? (
        timelineData.map((entry, index) => (
          <motion.div
            key={index}
            className="timeline-entry"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: 'easeOut' }}
            viewport={{ once: true }}
          >
            <div className="year">{entry.year}</div>
            <img
              src={`/media/svg/${wineColor}/${entry.trigram}.svg`}
              alt={entry.trigram}
              width={getSvgSize(entry.trigram)}
              height={getSvgSize(entry.trigram)}
            />
            <div className="legends">
              <div>{entry.legendReussite}</div>
              <div>{entry.legendEvolution}</div>
              <div>{entry.legendPuissance}</div>
            </div>
          </motion.div>
        ))
      ) : (
        <div>Aucune donnée disponible</div>
      )}
    </div>
  );
};

export default Timeline;
